import { Checkbox, FormControlLabel, FormGroup, Grid, Typography, Box, RadioGroup,Radio } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const CreateWOTaskDetails = ({ taskDetails, taskDetailsOptions, onChange }) => {

    const location = useLocation();
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const viewmode = location.state?.viewmode;
    const statusMapping = {
        "Open": 1,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed":7
    };
    const mappedStatus = statusMapping[status] || null;
    
    const handleCheckboxChange = (category, label) => (event) => {
        const checked = event.target.checked;
        const currentValues = taskDetails[category] ? taskDetails[category].split(', ') : [];
        let newValues = checked
            ? [...currentValues, label]
            : currentValues.filter((item) => item !== label);

        newValues = newValues.join(', ');
        onChange(category, newValues);
    };

    const renderRadiobutton = (id, label, values, options) => (
        <Box>
            <Typography variant="labelSm" color="text.primary" component="label">
                {label}
            </Typography>
            <RadioGroup
                value={values} // Ensure values is a single selected value
                onChange={(event) => onChange(id, event.target.value)} 
                row
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.id}
                        value={option.label} 
                        control={<Radio />}
                        label={option.label}
                        disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                    />
                ))}
            </RadioGroup>
        </Box>
    );
    
    const renderCheckboxGroup = (id, label, values, options) => (
        <Box>
            <Typography variant="labelSm" color="text.primary" component="label">
                {label}
            </Typography>
            <FormGroup row>
                {options.map((option) => (
                    <FormControlLabel
                        key={option.id}
                        control={
                            <Checkbox
                                checked={values.split(', ').includes(option.label)}
                                onChange={handleCheckboxChange(id, option.label)}
                                name={option.label}
                                disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                            />
                        }
                        label={option.label}
                    />
                ))}
            </FormGroup>
        </Box>
    );

    return (
        <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem',marginBottom: '1rem' }}>
            <Typography variant='title2' >Task Details</Typography>
        <Grid container spacing={3}>
            <Grid item xs={12} md={12} sm={12}>
                {renderRadiobutton(
                    'performanceTest',
                    'Performance Test',
                    taskDetails.performanceTest || "", // Ensure this is a string
                    taskDetailsOptions.performanceTest
                )}
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
                {renderRadiobutton(
                    'electricalSafetyTest',
                    'Electrical Safety Test',
                    taskDetails.electricalSafetyTest || "", // Ensure this is a string
                    taskDetailsOptions.electricalSafetyTest
                )}
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
                {renderCheckboxGroup(
                    'processStatus',
                    'Process Status',
                    taskDetails.processStatus || "", // Ensure this is a string
                    taskDetailsOptions.processStatus
                )}
            </Grid>
        </Grid>
        </Box>
    );
};

export default CreateWOTaskDetails;